import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';

class Monthly extends React.Component {
    renderTableBody(){
        const keys = [
            `1-${this.props.year}`,
            `2-${this.props.year}`,
            `3-${this.props.year}`,
            `4-${this.props.year}`,
            `5-${this.props.year}`,
            `6-${this.props.year}`,
            `7-${this.props.year}`,
            `8-${this.props.year}`,
            `9-${this.props.year}`,
            `10-${this.props.year}`,
            `11-${this.props.year}`,
            `12-${this.props.year}`
        ]
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'Jun',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
        if (this.props.c1 && this.props.c2 && this.props.c3){
            return keys.map((key, index) => {
                const getAmount = (data) => {
                    if(data){
                        return parseFloat(data.amount);
                    }else{
                        return 0;
                    }
                }
                const getPayPalFees = (collection, refunds) => {
                    let netFee = 0
                    if(collection){
                        netFee = parseFloat(collection.pay_pal_fees);
                    }
                    if(refunds){
                        netFee = netFee - parseFloat(refunds.pay_pal_fees);
                    }
                    return netFee.toFixed(2);
                }
                const getStripeFee = (collection, refunds) => {
                    let netFee = 0
                    if(collection){
                        const amount = parseFloat(collection.amount);
                        netFee = (amount * 0.029) + 0.30
                    }
                    const refund = refunds ? parseFloat(refunds.amount) : 0 
                    let refund_reversal = 0
                    if (refund > 0){
                        refund_reversal = (refund * 0.029) + 0.30
                    }
                    netFee = netFee - refund_reversal
                    return netFee.toFixed(2);
                }
                const getTotal = (c1pp, c1ppr, c1s, c1sr,
                    c2pp, c2ppr, c2s, c2sr,
                    c3pp, c3ppr, c3s, c3sr
                    ) => {
                    let total = 0
                    total = getAmount(c1pp) - getPayPalFees(c1pp, c1ppr) - getAmount(c1ppr) + getAmount(c1s) - getAmount(c1sr) - getStripeFee(c1s, c1sr) +
                            getAmount(c2pp) - getPayPalFees(c2pp, c2ppr) - getAmount(c2ppr) + getAmount(c2s) - getAmount(c2sr) - getStripeFee(c2s, c2sr) +
                            getAmount(c3pp) - getPayPalFees(c3pp, c3ppr) - getAmount(c3ppr) + getAmount(c3s) - getAmount(c3sr) - getStripeFee(c3s, c3sr) 
                    return total.toFixed(2);
                }
                return (<Table.Row key={index}>
                            <Table.Cell>{months[index]}</Table.Cell>
                            <Table.Cell className="c1 paypal">{getAmount(this.props.c1.payPalCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c1 pp-ref">{getAmount(this.props.c1.payPalRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c1 pp-fee">{getPayPalFees(this.props.c1.payPalCollections[`${index+1}-${this.props.year}`],this.props.c1.payPalRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c1 stripe">{getAmount(this.props.c1.stripeCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c1 st-ref">{getAmount(this.props.c1.stripeRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c1 st-fee">{getStripeFee(this.props.c1.stripeCollections[`${index+1}-${this.props.year}`], this.props.c1.stripeRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c2 paypal">{getAmount(this.props.c2.payPalCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c2 pp-ref">{getAmount(this.props.c2.payPalRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c2 pp-fee">{getPayPalFees(this.props.c2.payPalCollections[`${index+1}-${this.props.year}`],this.props.c2.payPalRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c2 stripe">{getAmount(this.props.c2.stripeCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c2 st-ref">{getAmount(this.props.c2.stripeRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c2 st-fee">{getStripeFee(this.props.c2.stripeCollections[`${index+1}-${this.props.year}`], this.props.c2.stripeRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c3 paypal">{getAmount(this.props.c3.payPalCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c3 pp-ref">{getAmount(this.props.c3.payPalRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c3 pp-fee">{getPayPalFees(this.props.c3.payPalCollections[`${index+1}-${this.props.year}`],this.props.c3.payPalRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c3 stripe">{getAmount(this.props.c3.stripeCollections[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c3 st-ref">{getAmount(this.props.c3.stripeRefunds[`${index+1}-${this.props.year}`])}    </Table.Cell>
                            <Table.Cell className="c3 st-fee">{getStripeFee(this.props.c3.stripeCollections[`${index+1}-${this.props.year}`], this.props.c3.stripeRefunds[`${index+1}-${this.props.year}`])}</Table.Cell>
                            <Table.Cell className="c3 total">
                                {getTotal(
                                    this.props.c1.payPalCollections[`${index+1}-${this.props.year}`],
                                    this.props.c1.payPalRefunds[`${index+1}-${this.props.year}`], 
                                    this.props.c1.stripeCollections[`${index+1}-${this.props.year}`],
                                    this.props.c1.stripeRefunds[`${index+1}-${this.props.year}`],
                                    this.props.c2.payPalCollections[`${index+1}-${this.props.year}`],
                                    this.props.c2.payPalRefunds[`${index+1}-${this.props.year}`], 
                                    this.props.c2.stripeCollections[`${index+1}-${this.props.year}`],
                                    this.props.c2.stripeRefunds[`${index+1}-${this.props.year}`], 
                                    this.props.c3.payPalCollections[`${index+1}-${this.props.year}`],
                                    this.props.c3.payPalRefunds[`${index+1}-${this.props.year}`], 
                                    this.props.c3.stripeCollections[`${index+1}-${this.props.year}`],
                                    this.props.c3.stripeRefunds[`${index+1}-${this.props.year}`])
                                }
                                
                                </Table.Cell>
                        </Table.Row>)
            })
        }else{
            return <Table.Row><Table.Cell>Fetching data...</Table.Cell></Table.Row>
        }
    }
    render () {
        return (
            <Table style={{fontSize: '12px'}}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell rowSpan='2'>Month</Table.HeaderCell>
                        <Table.HeaderCell colSpan='6'>C1</Table.HeaderCell>
                        <Table.HeaderCell colSpan='6'>C2</Table.HeaderCell>
                        <Table.HeaderCell colSpan='6'>C3</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='2'>Total</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>PayPal</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>PayPal Fee</Table.HeaderCell>
                        <Table.HeaderCell>Stripe</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>Stripe Fee</Table.HeaderCell>
                        <Table.HeaderCell>PayPal</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>PayPal Fee</Table.HeaderCell>
                        <Table.HeaderCell>Stripe</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>Stripe Fee</Table.HeaderCell>
                        <Table.HeaderCell>PayPal</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>PayPal Fee</Table.HeaderCell>
                        <Table.HeaderCell>Stripe</Table.HeaderCell>
                        <Table.HeaderCell>Refunds</Table.HeaderCell>
                        <Table.HeaderCell>Stripe Fee</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {this.renderTableBody()}
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        year: state.dashboard.year,
        c1: state.dashboard.c1,
        c2: state.dashboard.c2,
        c3: state.dashboard.c3,
     };
}

export default connect(mapStateToProps)(Monthly);